import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  ReferenceInput,
  PasswordInput,
  required,
  minLength,
  maxLength,
} from 'react-admin';
import { optionalPasswordValidator } from '../../utils/passwordValidation';

const validateUsername = [required(), minLength(3), maxLength(50)];
const validateRole = [required()];

export const UserEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled fullWidth />
      <TextInput source="username" validate={validateUsername} fullWidth />
      <PasswordInput
        source="password"
        label="New Password (leave empty to keep current)"
        helperText="At least 8 characters, with uppercase, lowercase, number and special character. Leave empty to keep current password."
        validate={optionalPasswordValidator}
        fullWidth
      />
      <SelectInput
        source="role"
        validate={validateRole}
        choices={[
          { id: 'Admin', name: 'Admin' },
          { id: 'Partner', name: 'Partner' },
        ]}
        fullWidth
      />
      <ReferenceInput source="groupId" reference="groups" label="Group">
        <SelectInput optionText="name" emptyText="No Group" fullWidth />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
